import api from './api';

// ─── Equipment Areas ─────────────────────────────────────────────────────────

export const getEquipmentAreas = async (params = {}) => {
  try {
    const response = await api.get('/equipment-areas', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching equipment areas:', error);
    throw error;
  }
};

export const createEquipmentArea = async (data) => {
  try {
    const response = await api.post('/equipment-areas', data);
    return response.data;
  } catch (error) {
    console.error('Error creating equipment area:', error);
    throw error;
  }
};

// ─── Work Orders ─────────────────────────────────────────────────────────────

export const getWorkOrders = async (params = {}) => {
  try {
    const response = await api.get('/maintenance/work-orders', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching work orders:', error);
    throw error;
  }
};

export const getWorkOrder = async (id) => {
  try {
    const response = await api.get(`/maintenance/work-orders/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching work order:', error);
    throw error;
  }
};

export const createWorkOrder = async (data) => {
  try {
    const response = await api.post('/maintenance/work-orders', data);
    return response.data;
  } catch (error) {
    console.error('Error creating work order:', error);
    throw error;
  }
};

export const updateWorkOrder = async (id, data) => {
  try {
    const response = await api.put(`/maintenance/work-orders/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating work order:', error);
    throw error;
  }
};

export const deleteWorkOrder = async (id) => {
  try {
    const response = await api.delete(`/maintenance/work-orders/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting work order:', error);
    throw error;
  }
};

export const reorderWorkOrders = async (order) => {
  try {
    const response = await api.post('/maintenance/work-orders/reorder', { order });
    return response.data;
  } catch (error) {
    console.error('Error reordering work orders:', error);
    throw error;
  }
};

// ─── Schedules ───────────────────────────────────────────────────────────────

export const getSchedules = async () => {
  try {
    const response = await api.get('/maintenance/schedules');
    return response.data;
  } catch (error) {
    console.error('Error fetching schedules:', error);
    throw error;
  }
};

export const getSchedule = async (id) => {
  try {
    const response = await api.get(`/maintenance/schedules/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching schedule:', error);
    throw error;
  }
};

export const createSchedule = async (data) => {
  try {
    const response = await api.post('/maintenance/schedules', data);
    return response.data;
  } catch (error) {
    console.error('Error creating schedule:', error);
    throw error;
  }
};

export const updateSchedule = async (id, data) => {
  try {
    const response = await api.put(`/maintenance/schedules/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating schedule:', error);
    throw error;
  }
};

export const deleteSchedule = async (id) => {
  try {
    const response = await api.delete(`/maintenance/schedules/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting schedule:', error);
    throw error;
  }
};

export const completeSchedule = async (id, data = {}) => {
  try {
    const response = await api.post(`/maintenance/schedules/${id}/complete`, data);
    return response.data;
  } catch (error) {
    console.error('Error completing schedule:', error);
    throw error;
  }
};

// ─── Customer Issues ─────────────────────────────────────────────────────────

export const getIssues = async (params = {}) => {
  try {
    const response = await api.get('/maintenance/issues', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching issues:', error);
    throw error;
  }
};

export const getIssue = async (id) => {
  try {
    const response = await api.get(`/maintenance/issues/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching issue:', error);
    throw error;
  }
};

export const createIssue = async (data) => {
  try {
    const response = await api.post('/maintenance/issues', data);
    return response.data;
  } catch (error) {
    console.error('Error creating issue:', error);
    throw error;
  }
};

export const updateIssue = async (id, data) => {
  try {
    const response = await api.put(`/maintenance/issues/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating issue:', error);
    throw error;
  }
};

export const deleteIssue = async (id) => {
  try {
    const response = await api.delete(`/maintenance/issues/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting issue:', error);
    throw error;
  }
};

// ─── Dashboard & Reports ─────────────────────────────────────────────────────

export const getDashboard = async () => {
  try {
    const response = await api.get('/maintenance/dashboard');
    return response.data;
  } catch (error) {
    console.error('Error fetching maintenance dashboard:', error);
    throw error;
  }
};

export const getCosts = async (params = {}) => {
  try {
    const response = await api.get('/maintenance/costs', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching maintenance costs:', error);
    throw error;
  }
};

export const getCapexSummary = async (params = {}) => {
  try {
    const response = await api.get('/maintenance/capex-summary', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching capex summary:', error);
    throw error;
  }
};


// ─── Standard Operating Procedures (SOPs) ────────────────────────────────────

export const getSOPs = async (params = {}) => {
  const response = await api.get('/maintenance/sops', { params });
  return response.data;
};

export const getSOP = async (id) => {
  const response = await api.get(`/maintenance/sops/${id}`);
  return response.data;
};

export const createSOP = async (data) => {
  const response = await api.post('/maintenance/sops', data);
  return response.data;
};

export const updateSOP = async (id, data) => {
  const response = await api.put(`/maintenance/sops/${id}`, data);
  return response.data;
};

export const deleteSOP = async (id) => {
  const response = await api.delete(`/maintenance/sops/${id}`);
  return response.data;
};

export const getSOPRevisions = async (id) => {
  const response = await api.get(`/maintenance/sops/${id}/revisions`);
  return response.data;
};

export const restoreSOPRevision = async (id, revisionId) => {
  const response = await api.post(`/maintenance/sops/${id}/revisions/${revisionId}/restore`);
  return response.data;
};

// Fetch SOPs from a specific location (overrides the default X-Location-Id
// header). Used by the cross-wash import flow so the admin can preview and
// pick from another wash's SOPs without switching their active location.
export const getSOPsForLocation = async (locationId, params = {}) => {
  const response = await api.get('/maintenance/sops', {
    params,
    headers: { 'X-Location-Id': String(locationId) },
  });
  return response.data;
};

export const importSOPs = async ({ sourceLocationId, sopIds }) => {
  const response = await api.post('/maintenance/sops/import', {
    source_location_id: sourceLocationId,
    sop_ids: sopIds && sopIds.length ? sopIds : undefined,
  });
  return response.data;
};

export const getArchivedSOPs = async () => {
  const response = await api.get('/maintenance/sops/archived');
  return response.data;
};

export const restoreArchivedSOP = async (revisionId) => {
  const response = await api.post(`/maintenance/sops/archived/${revisionId}/restore`);
  return response.data;
};
